// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__QQrhn","cards":"list_cards__RAeCC","no-data":"list_no-data__3wCx5","error-fetching":"list_error-fetching__cPlwM"};